import React, { useState, useEffect } from "react";
import Images from "../Images";
import tw from "tailwind-styled-components";
import Config from "../Config";
import axios from "axios";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import Loading from "react-loading";
import { Save_User, Save_Property, Select_Property, Save_Partners, Select_Partner, Save_Staff_Clients, Select_Staff_Client } from "../Redux/actions";
import { useNavigate } from "react-router-dom";
import { Field, Formik, Form } from "formik";
import { toast } from "react-toastify";
import { useMutation, useQuery } from "react-query";
import {
  SubmitBtn,
  InputGroup,
  FieldWrapper,
  Label,
} from "../Components/Styles/InputStyles";
import { useTranslation } from "react-i18next";
import { hasPermission, PERMISSION_ROUTE_MAP } from "../helpers";

const LoginRightInternal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [showOtpInput, setShowOtpInput] = useState(false);
  //const property = useSelector((state) => state.PropertyReducer.property);
  const InitialValue = {
    phone: "",
    otp: ["", "", "", "", "", ""],
  };

  //------- Send OTP Request -------
  const requestOtp = async (phone) => {
    return await axios.post(
      `${Config.apiUrl}/client/internal/login`,
      {
        mobile: phone,
        platform: 3,
      },
      null
    );
  };

  const onSuccess = (res) => {
    if (res?.data?.isSuccess === true) {
      setShowOtpInput(true);
    }
  };

  const onError = (res) => {
    toast.error(res?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: isLoadingOtp, mutate: postOtpRequest } = useMutation(
    requestOtp,
    {
      onSuccess: onSuccess,
      onError: onError,
    }
  );

  //------- Verify OTP Request -------
  const verifyOtp = async (values) => {
    const body = new FormData();
    body.append("mobile", values.phone);
    body.append("otp", values.otp.join(""));
    return await axios.post(
      `${Config.apiUrl}/client/otp/verify`,
      {
        mobile: values.phone,
        otp: values.otp.join(""),
      },
      null
    );
  };

  const onVerifySuccess = (res) => {
    if (res?.data?.isSuccess === true) {
      const expireAt = moment()
        .add(Config.sessionExpiredTime, "minutes")
        .valueOf();
      const token = res.data.token;
      const realData = {
        ...res.data.user, token, expireAt,
        permissions: res.data.user.permissions || 0,
      };
      //dispatch(Save_User(realData));

      // Call the property listing API
      // propertyListing(token).then((propertyRes) => {
      //   if (propertyRes) {
      //     dispatch(Save_Property(propertyRes?.data?.data));
      //     dispatch(Select_Property(propertyRes?.data?.data[0] || []));
      //     dispatch(Save_User(realData));
      //     navigate("/dashboard");
      //   }
      // });
      propertyListing(token).then((propertyRes) => {
        if (propertyRes) {
          const properties = propertyRes?.data?.data || [];

          const totalTenantCount = properties.reduce(
            (total, prop) => total + (prop.tenantCount || 0),
            0
          );
          const totalOccupiedBedCount = properties.reduce(
            (total, prop) => total + (prop.occupiedBedCount || 0),
            0
          );
          const totalBedCount = properties.reduce(
            (total, prop) => total + (prop.bedCount || 0),
            0
          );

          const allProperty = {
            id: 0,
            name: "All Properties",
            gId: "KIPINN",
            type: 0,
            tenantPreference: 3,
            tenantCount: totalTenantCount,
            occupiedBedCount: totalOccupiedBedCount,
            bedCount: totalBedCount,
          };
          const propertiesWithAll = [allProperty, ...properties];

          if (res.data.user.userType === 1) {
            dispatch(Save_Partners(res?.data?.personalAndPartnerProperties));
            dispatch(Select_Partner(res?.data?.personalAndPartnerProperties[0]));
          }
          if (res.data.user.userType === 3) {
            dispatch(Save_Staff_Clients(res?.data?.staffAccounts));
            dispatch(Select_Staff_Client(res?.data?.staffAccounts[0]));
          }
          dispatch(Save_Property(propertiesWithAll));
          dispatch(Select_Property(allProperty));
          dispatch(Save_User(realData));

          dispatch(Save_Property(propertiesWithAll));
          dispatch(Select_Property(allProperty));
          dispatch(Save_User(realData));
          if (res.data.user.userType === 1 || res.data.user.role === Config.STAFF_ROLES.ADMIN || res.data.user.role === Config.STAFF_ROLES.PARTNER || res.data.user.role === Config.STAFF_ROLES.FINANCEADMIN || res.data.user.role === Config.STAFF_ROLES.SALES_HEAD || res.data.user.role === Config.STAFF_ROLES.SALESPERSON || res.data.user.role === Config.STAFF_ROLES.IT_ADMIN) {
            navigate("/dashboard");
          } else if (res.data.user.userType === Config.USER_TYPE.LANDLORD) {
            navigate("/landlord/dashboard");
          }
          else {
            let finalRoute = "/property-list"; // default
            for (const item of PERMISSION_ROUTE_MAP) {
              if (hasPermission(item.permission, res.data.user)) {
                finalRoute = item.route;
                break;
              }
            }
            navigate(finalRoute);
          }
        }
      });
    }
  };

  const onVerifyError = (res) => {
    toast.error(res?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: isLoadingVerify, mutate: postVerifyOtp } = useMutation(
    verifyOtp,
    {
      onSuccess: onVerifySuccess,
      onError: onVerifyError,
    }
  );

  const handleGetOtp = (phone) => {
    if (!phone) {
      return toast.error("Please enter mobile number");
    }
    if (phone.length !== 10) {
      return toast.error("Please enter a valid 10-digit mobile number.");
    }
    postOtpRequest(phone);
  };

  const handleVerifyOtp = (values) => {
    if (values.otp.some((digit) => !digit)) {
      return toast.error("Please enter complete OTP");
    }
    postVerifyOtp(values);
  };

  const propertyListing = async (token) =>
    await axios.get(`${Config.apiUrl}/property/list/web/dropdown`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer" + " " + token,
      },
    });

  return (
    // <Logins>
    //   <TextWrapperComp
    //     InitialValue={InitialValue}
    //     handleGetOtp={handleGetOtp}
    //     handleVerifyOtp={handleVerifyOtp}
    //     isLoadingOtp={isLoadingOtp}
    //     isLoadingVerify={isLoadingVerify}
    //     showOtpInput={showOtpInput}
    //     t={t}
    //   />
    // </Logins>
    <Logins className="relative">
      <TextWrapperComp
        InitialValue={InitialValue}
        handleGetOtp={handleGetOtp}
        handleVerifyOtp={handleVerifyOtp}
        isLoadingOtp={isLoadingOtp}
        isLoadingVerify={isLoadingVerify}
        showOtpInput={showOtpInput}
        t={t}
      />
      {/* Footer Image*/}
      <FooterSection>
        <img
          src={Images.FooterImg}
          alt="footer"
          className="w-full h-auto opacity-50"
        />
      </FooterSection>
    </Logins>
  );
};

const TextWrapperComp = ({
  InitialValue,
  handleGetOtp,
  handleVerifyOtp,
  isLoadingOtp,
  isLoadingVerify,
  showOtpInput,
  t,
}) => (
  <TextWrapper>
    <Container>
      <Center>
        <div className="flex space-x-6 opacity-75">
          <Logo src={Images.LoginLogo} alt="logo" />
        </div>
        <Title>{"Please Login with your Mobile Number"}</Title>
        <Formik
          initialValues={InitialValue}
          onSubmit={
            showOtpInput
              ? handleVerifyOtp
              : (values) => handleGetOtp(values.phone)
          }
        >
          {({ values, setFieldValue }) => (
            <Form className="w-full">
              <FormContainer>
                <InputGroup>
                  <Label htmlFor="phone">{"Mobile Number"}</Label>
                  <FieldWrapper>
                    <Field
                      name="phone"
                      id="phone"
                      type="text"
                      maxLength={10}
                      autoComplete="off"
                    />
                  </FieldWrapper>
                </InputGroup>
                {showOtpInput && (
                  <div className="flex justify-end items-center max-w-sm space-x-2">
                    <div className="text-gray-500 sm:text-sm md:text-sm lg:text-md">
                      Did not receive an OTP?
                    </div>
                    <button
                      type="button"
                      onClick={() => handleGetOtp(values.phone)}
                      className="text-blue-600 font-medium sm:text-sm md:text-sm lg:text-md"
                      disabled={isLoadingOtp}
                    >
                      Resend OTP
                    </button>
                  </div>
                )}

                {showOtpInput && (
                  <InputGroup>
                    <Label htmlFor="otp">{"Enter OTP"}</Label>
                    <div className="flex space-x-2">
                      {[0, 1, 2, 3, 4, 5].map((index) => (
                        <input
                          key={index}
                          type="text"
                          inputmode="numeric"
                          maxLength={1}
                          className="w-10 h-10 text-center border rounded"
                          value={values.otp[index]}
                          onChange={(e) => {
                            const inputValue = e.target.value.replace(
                              /[^0-9]/g,
                              ""
                            );
                            if (inputValue.length > 1) return;
                            const newOtp = [...values.otp];
                            newOtp[index] = inputValue;
                            setFieldValue("otp", newOtp);
                            if (e.target.value && index < 5) {
                              document
                                .getElementById(`otp-${index + 1}`)
                                .focus();
                            }
                          }}
                          onKeyDown={(e) => {
                            if (
                              e.key === "Backspace" &&
                              !values.otp[index] &&
                              index > 0
                            ) {
                              document
                                .getElementById(`otp-${index - 1}`)
                                .focus();
                            } else if (e.key === "ArrowLeft" && index > 0) {
                              document
                                .getElementById(`otp-${index - 1}`)
                                .focus();
                            } else if (e.key === "ArrowRight" && index < 5) {
                              document
                                .getElementById(`otp-${index + 1}`)
                                .focus();
                            }
                          }}
                          id={`otp-${index}`}
                        />
                      ))}
                    </div>
                  </InputGroup>
                )}
              </FormContainer>
              {/* {showOtpInput && (
                // <div className="flex justify-end max-w-sm mt-1">
                //   <button
                //     type="button"
                //     onClick={() => handleGetOtp(values.phone)}
                //     className=" text-blue-600"
                //     disabled={isLoadingOtp}
                //   >
                //     Resend OTP
                //   </button>
                // </div>
                <div className="flex justify-center items-center max-w-sm mt-1 space-x-2">
                  <div>Did not receive an OTP?</div>
                  <button
                    type="button"
                    onClick={() => handleGetOtp(values.phone)}
                    className="text-blue-600 border-b-1 font-medium"
                    disabled={isLoadingOtp}
                  >
                    Resend OTP
                  </button>
                </div>

              )} */}
              <div className="mt-4 lg:mt-10 flex">
                <SubmitBtn
                  className="bg-[rgb(0,120,189,0.7)]"
                  type="submit"
                  disabled={isLoadingOtp || isLoadingVerify}
                >
                  {isLoadingOtp || isLoadingVerify ? (
                    <Loading
                      color="white"
                      width={20}
                      height={20}
                      noPadding={true}
                    />
                  ) : showOtpInput ? (
                    "Verify OTP"
                  ) : (
                    "Get OTP"
                  )}
                </SubmitBtn>
              </div>
            </Form>
          )}
        </Formik>
      </Center>
    </Container>
  </TextWrapper>
);

const FormContainer = tw.div`grid max-w-sm mt-8 w-full gap-5 sm:gap-6 md:gap-7 lg:gap-8`;
// const Logins = tw.section`h-screen flex bg-white justify-center items-center px-6 sm:px-10 md:px-12 lg:px-16 xl:px-20`;
const Logins = tw.section`h-dvh flex bg-white justify-center items-center px-6 sm:px-10 md:px-12 lg:px-16 xl:px-20`;
const FooterSection = tw.div`lg:hidden md:block sm:block absolute bottom-0 left-0 w-full`;
const Container = tw.div`flex flex-col h-full w-full justify-center items-start px-4 sm:px-6 md:px-8 lg:px-10`;
const Logo = tw.img`w-20 h-20 object-contain mb-10 sm:w-24 sm:h-24 md:w-28 md:h-28`;
const TextWrapper = tw.div`h-full relative sm:max-w-sm sm:text-lg md:w-full md:max-w-md md:text-xl lg:max-w-lg lg:text-base xl:max-w-xl xl:text-lg`;
const Title = tw.h1`text-lg sm:text-2xl font-light text-gray-800 tracking-wider md:text-3xl lg:text-xl`;
const Center = tw.div`h-full w-full py-10 pt-20 mb-5 flex flex-col sm:py-12 md:py-14 lg:py-16`;

export default LoginRightInternal;
